export const FORM_ORDER: Array<{ name: string, route: string }> = [
  {name: 'sales', route: '../sales'},
  {name: 'cash-payouts', route: '../cash-payouts'},
  {name: 'cash-payins', route: '../cash-payins'},
  {name: 'received-on-account', route: '../received-on-account'},
  {name: 'account-sales', route: '../account-sales'},
  {name: 'cash-deposits', route: '../deposits/cash-deposits'},
  {name: 'cash-on-hand-deposits', route: '../cash-on-hand-deposits'},
  {name: 'speedpoint-deposits', route: '../speedpoint-deposits'},
  {name: 'check-deposits', route: '../check-deposits'},
  {name: 'snapscan-deposits', route: '../snapscan-deposits'},
  {name: 'zapper-deposits', route: '../zapper-deposits'},
  {name: 'voucher-deposits', route: '../voucher-deposits'},
  {name: 'wigroup-deposits', route: '../wigroup-deposits'},
  {name: 'fuel-card-deposits', route: '../fuel-card-deposits'},
  {name: 'eft-deposits', route: '../eft-deposits'},
  {name: 'float-control', route: '../../float-control'},
  {name: 'shorts', route: '../shorts'},
  {name: 'voids', route: '../voids'},
];



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/constants/form-order.ts